module.exports = __webpack_public_path__ + "catalog/items/bookcase/bookTexture2.jpg";